import React, { Component } from 'react'

import classes from './Uom.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/Uom/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class Uom extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      uom_name: {
        label: 'uom',
        elementType: 'input',
        elementConfig: {
          placeholder: 'UOM Name'
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: 'company',
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: 'Select Company',
          options: [{ value: '', label: 'Select Company' }]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_date: {
        label: 'isDate',
        elementType: 'checkbox',
        value: false,
        validation: false,
        valid: true
      },
      is_active: {
        label: 'active',
        elementType: 'checkbox',
        value: true,
        validation: true,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: 'company',
        value: '',
        configs: {
          placeholder: 'Select Company',
          options: [{ value: '', label: 'Select Company' }]
        }
      },
      uom_id: {
        label: 'uom',
        value: '',
        configs: {
          placeholder: 'Select UOM Name',
          options: [{ value: '', label: 'Select UOM Name' }]
        }
      },
      is_active: {
        label: 'active',
        value: '',
        configs: {
          placeholder: 'Select Active',
          options: [
            { value: 1, label: this.props.translate('active') },
            { value: 0, label: this.props.translate('inactive') }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterUom: this.props.filterUom
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: `${this.props.translate('add') + this.props.translate('uom')}`,
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: `${this.props.translate('edit') + this.props.translate('uom')}`,
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.uom_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: `${this.props.translate('delete') + this.props.translate('uom')}`,
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.uom_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'uom_name', title: this.props.translate('uom'), type: 'string' },
    {
      field: 'company_name',
      title: this.props.translate('company'),
      type: 'string',
      render: rowData => {
        return rowData.company?.company_name
      }
    },
    {
      field: 'is_date',
      title: this.props.translate('isDate'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_date} disabled />
      },
      width: 100
    },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchUom()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = {
        ...updatedState,
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: {
          ...updateProps,
          [propsId]: props[propsId]
        }
      }
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = {
        ...updatedState,
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: {
          ...updateProps,
          [propsId]: props[propsId]
        }
      }
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterUom !== updateProps.filterUom) {
      updateFilter('uom_id', 'filterUom', ['uom_id', 'uom_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newUomData = Object.entries(state.inputGroups).reduce((uomGroups, uom) => {
        let [uomKey, uomAttrs] = uom
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!uomAttrs.validation || !uomAttrs.validation.required) {
          valid = true
        }
        if (uomAttrs.elementType === 'checkbox') {
          value = false
        } else if (uomAttrs.elementType === 'datePicker') {
          value = new Date()
        }
        if (props.selectedRecord && props.selectedRecord[uomKey]) {
          value = props.selectedRecord[uomKey]

          let { isValid, error } = checkValidity(value, uomAttrs.validation, uomAttrs.label)
          if (uomAttrs.elementType === 'newselect') {
            value = state.inputGroups[uomKey].elementConfig.options.find(res => res.value === value)
          }
          if (uomAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newUomAttrs = {
          ...uomAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(uomGroups, { [uomKey]: { ...newUomAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        inputGroups: newUomData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }
  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchUom(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchUom(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }

          break
        case 'is_date':
          newFormAttrs = {
            ...formAttrs,
            value: false
          }

          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return {
        ...formGroups,
        [formKey]: { ...newFormAttrs }
      }
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchUomById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    // if (this.state.action === 'edit') {
    this.clearModal()
    // } else {
    this.setState({
      modalOpen: false
    })
    // }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  uomSubmitHandler = type => {
    let uomData = Object.entries(this.state.inputGroups).reduce((uomData, uomEntry) => {
      let value = ''
      let [uomKey, uomAttrs] = uomEntry
      if (uomAttrs.elementType === 'newselect') {
        value = uomAttrs.value?.value
      } else {
        value = uomAttrs.value
      }
      return { ...uomData, [uomKey]: value }
    }, {})

    if (this.state.action === 'add') {
      this.props.createUom({ ...uomData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateUom(
        this.state.actionRecordId,
        { ...uomData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (groupKey, uomKey, event) => {
    const inputGroup = this.state.inputGroups
    const uomItem = inputGroup[uomKey]
    let inputValue = ''

    switch (uomItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !uomItem.value
        break
      case 'datePicker':
        inputValue = event
        break
      default:
        inputValue = event.target.value
        break
    }
    if (uomKey === 'appraisal_type_id') {
      this.props.fetchParentUomOptions(inputValue.value)
    }
    const { isValid, error } = checkValidity(inputValue, uomItem.validation, uomItem.label)

    const updatedUomItem = {
      ...uomItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [uomKey]: updatedUomItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateGroup,
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteUom(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchFilter({ company_id: filterValue?.value })
    }
    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: updateObject(filterItem, { value: filterValue })
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchUom(param)
    this.closeFilterModal()
  }

  render() {
    let uomLabel = <Spinner />

    if (!this.props.loading) {
      uomLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(uomKey, e) => this.inputChangeHandler(key, uomKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.uomSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.uomSubmitHandler('save')}
        another={() => this.uomSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + ' ' + this.props.translate('uom')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{uomLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('uom')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.uom.pagination,
    data: state.uom.records,
    loading: state.uom.loading,
    filterLoading: state.uom.filterLoading,
    success: state.uom.success,
    selectedRecord: state.uom.selectedRecord,
    companyOptions: state.uom.company,
    filterCompany: state.uom.filterCompany,
    filterUom: state.uom.filterUom,
    loadingQueue: state.uom.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUom: filterOptions => dispatch(actions.fetchUom(filterOptions)),
    fetchUomById: recordId => dispatch(actions.fetchUomById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedUomRecord()),
    createUom: (recordData, page) => dispatch(actions.createUom(recordData, page)),
    updateUom: (recordId, recordData, page) =>
      dispatch(actions.updateUom(recordId, recordData, page)),
    deleteUom: (recordId, page) => dispatch(actions.deleteUom(recordId, page)),
    fetchCompanyOptions: recordId => dispatch(actions.fetchCompanyOptions(recordId)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchUomFilterUom(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Uom))
